var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Button as MButton, CircularProgress, Tooltip, } from '@mui/material';
const DisabledWrapper = forwardRef((_a, ref) => {
    var { disabled, children } = _a, props = __rest(_a, ["disabled", "children"]);
    return disabled ? (_jsx("div", Object.assign({ ref: ref }, props, { children: children }))) : (_jsx(_Fragment, { children: children }));
});
const TooltipWrapper = (_a) => {
    var { tooltipText, children } = _a, props = __rest(_a, ["tooltipText", "children"]);
    return tooltipText ? (_jsx(Tooltip, Object.assign({ title: tooltipText }, { children: _jsx(DisabledWrapper, Object.assign({}, props, { children: children })) }))) : (_jsx(DisabledWrapper, Object.assign({}, props, { children: children })));
};
const Button = (_a) => {
    var { isLoading, tooltipText, children } = _a, props = __rest(_a, ["isLoading", "tooltipText", "children"]);
    const { color = 'primary', variant = 'contained' } = props;
    const tooltipWrapperProps = tooltipText
        ? {
            disabled: props.disabled,
            className: props.className,
            tooltipText,
        }
        : undefined;
    return (_jsx(TooltipWrapper, Object.assign({}, tooltipWrapperProps, { children: _jsx(MButton, Object.assign({}, props, { color: color, variant: variant, disabled: props.disabled || isLoading, endIcon: isLoading ? _jsx(CircularProgress, { size: "1rem" }) : '', className: !(props.disabled && tooltipText) ? props.className : undefined }, { children: children })) })));
};
export default Button;
